module.exports = __webpack_public_path__ + "img/ComeBuy.21413db5.svg";